module.exports = __webpack_public_path__ + "img/Black.png";